import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { LOCALE_ID } from '@angular/core';
import { registerLocaleData } from '@angular/common';

import { AppComponent } from './app.component';
import { HeaderComponent } from './header/header.component';
import { SearchComponent } from './search/search.component';
import { AppRoutingModule } from './app-routing.module';
import { SearchFooterComponent } from './search-footer/search-footer.component';
import { FooterComponent } from './footer/footer.component';
import { MatButtonToggleModule, MatDatepickerModule, MatNativeDateModule, MatFormFieldModule, MatInputModule } from '@angular/material';
import { SatDatepickerModule, SatNativeDateModule } from 'saturn-datepicker';
import { RoomsComponent } from './rooms/rooms.component';
import { SearchBodyComponent } from './search-body/search-body.component';
import { PaymentComponent } from './payment/payment.component';
import { HttpClientModule } from '@angular/common/http';
import { RoomComponent } from './room/room.component';
import { HeaderRoomsComponent } from './header-rooms/header-rooms.component';

import localePt from '@angular/common/locales/pt';
import { PreviaReservaComponent } from './previa-reserva/previa-reserva.component';
import { FormsModule } from '@angular/forms';
import { CompanyComponent } from './company/company.component';
import { ErrorComponent } from './error/error.component';
import { TabelaDePrecosComponent } from './tabela-de-precos/tabela-de-precos.component';
import { CreditCardComponent } from './credit-card/credit-card.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MotorService } from './services/motor.service';
import { SuccessComponent } from './success/success.component';

//extern
import { NgxSpinnerModule } from 'ngx-spinner';

registerLocaleData(localePt);

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    SearchComponent,
    SearchFooterComponent,
    FooterComponent,
    RoomsComponent,
    SearchBodyComponent,
    PaymentComponent,
    RoomComponent,
    HeaderRoomsComponent,
    PaymentComponent,
    PreviaReservaComponent,
    CompanyComponent,
    ErrorComponent,
    TabelaDePrecosComponent,
    CreditCardComponent,
    SuccessComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    AppRoutingModule,
    HttpClientModule,
    MatButtonToggleModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatNativeDateModule,
    MatInputModule,
    SatDatepickerModule, 
    SatNativeDateModule,
    NgbModule,
    NgxSpinnerModule
  ],
  exports: [],
  providers: [
    MotorService,
    // {provide: HAMMER_GESTURE_CONFIG, useClass: CustomHammerConfig},
    {provide: LOCALE_ID, useValue: 'pt-BR'}
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
